type WillEmptySourceEndpointInput = {
  selectedCount: number;
  sourceHarTotalCount: number;
};

export const willEmptySourceEndpoint = ({
  selectedCount,
  sourceHarTotalCount,
}: WillEmptySourceEndpointInput): boolean =>
  selectedCount > 0 && selectedCount === sourceHarTotalCount;
